import * as coreEntities from '_core/store/index';
import { CLIENT } from '_core/variables/constant';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useSystemSettings from './useSystemSettings';

export function useOrganization() {
  const client = useSelector((state) => coreEntities.organization.selectors.getClient(state));
  const tenantData = useSelector((state) => coreEntities.organization.selectors.getTenant(state));
  const featureFlags = useSelector((state) => coreEntities.organization.selectors.getFeatureFlags(state));
  const canCreateGroup = useSelector((state) => coreEntities.organization.selectors.getCanCreateGroup(state));
  const canCreateCourse = useSelector((state) => coreEntities.organization.selectors.getCanCreateCourse(state));

  const { enableThirdPartyIntegrations } = useSystemSettings();

  const [canChangeAvatar, setCanChangeAvatar] = useState(true);
  const [hasSupport, setHasSupport] = useState(true);
  const [showAccountTab, setShowAccountTab] = useState(true);
  const [showDisregardedPrograms, setShowDisregardedPrograms] = useState(true);
  const [showKidsMode, setShowKidsMode] = useState(CLIENT.SANTILLANA_PILOTO);
  const [canEditProfileInfo, setCanEditProfileInfo] = useState(true);
  const [canEditCourse, setCanEditCourse] = useState(true);
  const [logoutRedirect, setLogoutRedirect] = useState(client === CLIENT.EDELVIVES || client === CLIENT.SANTILLANA_ALFA);
  const [hideLibrary, setHideLibrary] = useState(false);
  const [hideTeacher, setHideTeacher] = useState(false);
  const [hideEducationLevelGroup, setHideEducationLevelGroup] = useState(false);
  const [newProgramInterface, setNewProgramInterface] = useState(client === CLIENT.TANGERINE);

  useEffect(() => {
    if (client) {
      setShowKidsMode(client === CLIENT.SANTILLANA_PILOTO);
    }
  }, [client]);

  useEffect(() => {
    if (enableThirdPartyIntegrations) {
      setCanChangeAvatar(false);
      setHasSupport(false);
      setShowAccountTab(false);
      setShowDisregardedPrograms(false);
      setCanEditProfileInfo(false);
      setCanEditCourse(false);

      setLogoutRedirect(true);
      setHideLibrary(true);
      setHideTeacher(true);
      setHideEducationLevelGroup(true);
      setNewProgramInterface(true);
    }
  }, [enableThirdPartyIntegrations]);

  // const canChangeAvatar =
  //   client !== CLIENT.SANTILLANA_PILOTO &&
  //   client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
  //   client !== CLIENT.SANTILLANA_INTEGRATIONS &&
  //   client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
  //   client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;
  // const hasSupport =
  //   client !== CLIENT.SANTILLANA_PILOTO &&
  //   client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
  //   client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
  //   client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;
  // const showAccountTab =
  //   client !== CLIENT.SANTILLANA_PILOTO &&
  //   client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
  //   client !== CLIENT.SANTILLANA_INTEGRATIONS &&
  //   client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
  //   client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;
  // const showDisregardedPrograms =
  //   client !== CLIENT.SANTILLANA_PILOTO && client !== CLIENT.SANTILLANA_COLOMBIA_DEMO && client !== CLIENT.SANTILLANA_INTEGRATIONS;
  // const showKidsMode = client === CLIENT.SANTILLANA_PILOTO;
  // const canEditProfileInfo =
  //   client !== CLIENT.SANTILLANA_PILOTO &&
  //   client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
  //   client !== CLIENT.SANTILLANA_INTEGRATIONS &&
  //   client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
  //   client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;
  // const canEditCourse =
  //   client !== CLIENT.SANTILLANA_PILOTO &&
  //   client !== CLIENT.SANTILLANA_COLOMBIA_DEMO &&
  //   client !== CLIENT.SANTILLANA_INTEGRATIONS &&
  //   client !== CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM &&
  //   client !== CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;

  // const logoutRedirect =
  //   client === CLIENT.SANTILLANA_PILOTO ||
  //   client === CLIENT.SANTILLANA_INTEGRATIONS ||
  //   client === CLIENT.SANTILLANA_ALFA ||
  //   client === CLIENT.EDELVIVES ||
  //   client === CLIENT.SANTILLANA_COLOMBIA_DEMO;
  // const hideLibrary = client === CLIENT.SANTILLANA_PILOTO || client === CLIENT.SANTILLANA_COLOMBIA_DEMO || client === CLIENT.SANTILLANA_INTEGRATIONS;
  // const hideTeacher = client === CLIENT.SANTILLANA_PILOTO || client === CLIENT.SANTILLANA_COLOMBIA_DEMO || client === CLIENT.SANTILLANA_INTEGRATIONS;
  // const hideEducationLevelGroup =
  //   client === CLIENT.SANTILLANA_PILOTO || client === CLIENT.SANTILLANA_INTEGRATIONS || client === CLIENT.SANTILLANA_COLOMBIA_DEMO;
  // const newProgramInterface =
  //   client === CLIENT.TANGERINE ||
  //   client === CLIENT.SANTILLANA_BRASIL_DEMO ||
  //   client === CLIENT.SANTILLANA_BRASIL_COMPARTILHA ||
  //   client === CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM ||
  //   client === CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM;

  return {
    client,
    tenantConfig: {
      ...tenantData,
      ...featureFlags,
      hideTeacher,
      showLogout: true,
      canChangeAvatar,
      hasSupport,
      showAccountTab,
      canCreateGroup,
      canCreateCourse,
      showDisregardedPrograms,
      showKidsMode,
      hideLibrary,
      hideEducationLevelGroup,
      canEditProfileInfo,
      canEditCourse,
      logoutRedirect,
      newProgramInterface,
    },
  };
}
